import React, { useState, useEffect } from "react";
import "./PodcastPage.css";

const SpotifyPage = () => {
  const [podcasts, setPodcasts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadTracks = async () => {
      try {
        fetch("./podcasts.json")
          .then((response) => response.json())
          .then((data) => {
            const validPodcasts = data.filter((podcast) => podcast.name);
            setPodcasts(validPodcasts);
            setIsLoading(false);
          })
          .catch((error) => {
            console.error("Error loading JSON:", error);
            setIsLoading(false);
          });
      } catch (error) {
        console.error("Error loading JSON data:", error);
        setIsLoading(false);
      }
    };

    loadTracks();
  }, []);

  if (isLoading) {
    return <div class="loading"></div>;
  }

  return (
    // <div className="container">
    //   <div className="header">
    //     <h1>My Podcasts</h1>
    //     <p>{podcasts.length} podcasts</p>
    //   </div>

    //   <div className="trackListHeader">
    //     <div className="trackNumber">#</div>
    //     <div className="trackInfo">TITLE</div>
    //   </div>

    //   <div className="trackList">
    //     {podcasts.map((podcast, index) => (
    //       <div
    //         key={podcast["link"] || index}
    //         className="trackItem"
    //         style={{
    //           animationDelay: "0.1s",
    //         }}
    //         onClick={() => window.open(`${podcast["link"]}`)}
    //       >
    //         <div className="trackNumber">{index + 1}</div>
    //         <div className="trackInfo">
    //           <div className="trackName">{podcast["name"]}</div>
    //           <div className="artistName">
    //             {podcast["category"] &&
    //               podcast["category"].map((cat, i) => (
    //                 <span
    //                   key={i}
    //                   style={{
    //                     background: "rgba(255,255,255,0.1)",
    //                     padding: "4px 8px",
    //                     borderRadius: "12px",
    //                     fontSize: "0.8rem",
    //                     marginRight: "8px",
    //                     marginTop: "4px",
    //                     display: "inline-block",
    //                   }}
    //                 >
    //                   {cat}
    //                 </span>
    //               ))}
    //           </div>
    //         </div>
    //       </div>
    //     ))}
    //   </div>
    // </div>

    <div className="container">
      <div className="header">
        <h1>My Favorite Podcasts</h1>
        <p>{podcasts.length} podcasts</p>
      </div>

      <div className="trackListHeader">
        <div className="trackNumber">#</div>
        <div className="trackInfoTitle">TITLE</div>
        <div className="trackCategoryTitle">CATEGORY</div>
      </div>

      <div className="trackList">
        {podcasts.map((podcast, index) => (
          <div
            key={podcast["link"] || index}
            className="trackItem"
            style={{
              animationDelay: "0.1s",
            }}
            onClick={() => window.open(`${podcast["link"]}`)}
          >
            <div className="trackNumber">{index + 1}</div>
            <div className="trackInfo">
              <div className="trackName">{podcast["name"]}</div>
              <div className="trackLink">{podcast["link"]}</div>
            </div>
            <div className="trackCategory">
              {podcast["category"] &&
                podcast["category"].map((cat, i) => (
                  <span
                    key={i}
                    style={{
                      background: "rgba(255,255,255,0.1)",
                      padding: "4px 8px",
                      borderRadius: "12px",
                      fontSize: "0.8rem",
                      marginRight: "8px",
                      marginTop: "4px",
                      display: "inline-block",
                    }}
                  >
                    {cat}
                  </span>
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpotifyPage;
